// CustomerForm.jsx
import React, { useState, useEffect } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { validatePhone } from "../../config/function";

const CustomerForm = ({ selectedData, onSave, onCancel }) => {
  const [customerData, setCustomerData] = useState({
    name: "",
    email: "",
    password: "",
    phone: "",
  });

  useEffect(() => {
    if (selectedData) {
      setCustomerData(selectedData);
    } else {
      setCustomerData({
        name: "",
        email: "",
        password: "",
        phone: ""
      });
    }
  }, [selectedData]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === 'phone') {
      if (validatePhone(value)) {
        setCustomerData((prev) => ({ ...prev, [name]: value }))
      }
      return;
    }
    setCustomerData((prev) => ({ ...prev, [name]: value }));


  };

  const handleSubmit = (e) => {
    e.preventDefault();

    let finalData = { ...customerData }
    if (selectedData && customerData === '') {
      finalData.password = selectedData.password
    }
    onSave(finalData);
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Row className="mb-3">
        <Form.Label column sm="3">Name</Form.Label>
        <Col sm="5">
          <Form.Control
            type="text"
            name="name"
            value={customerData.name}
            onChange={handleChange}
            required
            placeholder="Enter customer name"
          />
        </Col>
      </Row>

      <Row className="mb-3">
        <Form.Label column sm="3">Email</Form.Label>
        <Col sm="5">
          <Form.Control
            type="text"
            name="email"
            value={customerData.email}
            onChange={handleChange}
            placeholder="Enter Email id"
            required
          />
        </Col>
      </Row>

      <Row className="mb-3">
        <Form.Label column sm="3">
          Password
        </Form.Label>
        <Col sm="5">
          <Form.Control
            type="text"
            name="password"
            value={customerData.password}
            onChange={handleChange}
            placeholder="Enter the password"
            required={!selectedData}
          />
        </Col>
      </Row>

      <Row className="mb-3">
        <Form.Label column sm="3">
          Mobile No
        </Form.Label>
        <Col sm="5">
          <Form.Control
            type="text"
            name="phone"
            value={customerData.phone}
            onChange={handleChange}
            placeholder="Enter the mobile number"
            required
          />
        </Col>
      </Row>

      {/* Buttons */}
      <div className="text-end mt-4">
        <Button variant="secondary" className="me-2" onClick={onCancel}>
          Cancel
        </Button>
        <Button variant="primary" type="submit">
          {selectedData ? "Update" : "Submit"}
        </Button>
      </div>
    </Form>
  );
};

export default CustomerForm;